import { post } from "../http/platformServer";
import OrderDTO from "@/dto/order/OrderDTO";
import { LogType } from "./moreFeatures/logs";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";

export interface OrderLogDTO {
    /**
     * 日志内容
     */
    content: string;
    /**
     * 额外数据的JSON字符串，用于前端需根据日志里的某些字段信息处理业务逻辑，目前部分日志有extraData，如：
     * WaybillLog：logisticsCompany、waybillNos
     * ShipLog：logisticsCompany、waybillNo
     * OrderItemLog：orderItemId
     * WaybillNoLog：waybillNo
     */
    extraData: string;
    /**
     * 日志记录的ID
     */
    id: number;
    /**
     * IP地址
     */
    ip: string;
    /**
     * 日志类型
     */
    logType: LogType;
    /**
     * 操作类型
     */
    operationType: string;
    /**
     * 操作类型中文描述
     */
    operationTypeDesc: string;
    /**
     * 订单ID
     */
    orderId: number;
    /**
     * 订单编号
     */
    orderOriginalId: string;
    /**
     * 店铺ID
     */
    shopId: number;
    /**
     * 拆分子订单的订单编号
     */
    splitChildOrderOriginalId: string;
    /**
     * 操作时间
     */
    time: string;
    /**
     * 操作人
     */
    username: string;
}

export function getOrderLogs(order: OrderDTO, logType: LogType) {
    const shopId = order.shopId;
    const mergeSplitStatus = order.mergeSplitStatus;

    /** 订单ID列表，如果是合并订单需传所有子订单的ID */
    const orderIds =
        mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT ? order.childOrders?.map(({ id }) => id) : [order.id];

    const params = { shopId, orderIds, logType };

    return post<OrderLogDTO[]>(shopId, `/order/oplog/list_by_order_ids`, params);
}
